import { Router } from '@bingads-webui/router';
import { lastNDate } from '@bingads-webui-universal/primitive-utilities';

export const handleUnauthorizedResponse = (err) => {
  if (err && err.status === 401) {
    Router.navigate('/default.aspx?reason=1&msg=sessionexpired');
  }
};

/**
 * if the endDate is in recent 7 days, we should enable card data in request.
 * @param {Object} query - query.endDate is in format mm/dd/yyyy.
 * @returns {bool} value of CardDataEnabled in request.
 * */
export const isCardDataEnabled = (query) => {
  const endDate = new Date(query.endDate);
  const today = new Date();
  const sevenDaysAgo = lastNDate(today, 7);

  return endDate >= sevenDaysAgo;
};
